import React, { memo } from 'react';
import classnames from 'classnames';
import { Skeleton } from 'site-modules/shared/components/skeleton/skeleton';

import './highlights-skeleton.scss';

export const HighlightsSkeleton = memo(() => (
  <div className="highlights-skeleton mt-0_75 mb-1_5">
    {new Array(6).fill(null).map((item, index) => (
      <div
        className={classnames('d-flex', {
          'mt-1_5': index !== 0,
        })}
        key={index} // eslint-disable-line react/no-array-index-key
      >
        <Skeleton
          className={classnames('rounded-6 height-16', {
            'w-50': index % 2 === 0,
            'w-55': index % 2 !== 0,
          })}
        />
        <Skeleton
          className={classnames('rounded-6 height-16 ms-auto', {
            'w-30': index % 2 === 0,
            'w-25': index % 2 !== 0,
          })}
        />
      </div>
    ))}
  </div>
));

HighlightsSkeleton.displayName = 'HighlightsSkeleton';
